<template lang="pug" src="./custom-fun-img-row.pug"></template>

<script>
export default {
  props: ['props'],
  methods: {
    fadeUp () {
      for (let i = 0; i <= 3; i++) {
        this.$refs.img[i].classList.add('pop-in')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-fun-img-row.vue?b4eae5c8